import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ChannelCategory } from 'icreate/common/models/channel-category';
import { BehaviorSubject, lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ChannelCategoryService {
    private domain: string;
    private listSubject = new BehaviorSubject<ChannelCategory[]>([]);

    public list$ = this.listSubject.asObservable();

    addNewCateogry = new EventEmitter<ChannelCategory>();

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    setList(channelCategoryList: ChannelCategory[]) {
        this.listSubject.next(channelCategoryList);
    }

    public async getList(vesselId: string) {
        try {
            const channelCategoryList = await lastValueFrom(
                this.http.get<ChannelCategory[]>(`${this.domain}/api/channel-categories`, {
                    params: {
                        vesselId,
                    },
                })
            );
            this.setList(channelCategoryList);
            return channelCategoryList;
        } catch (error) {
            console.error(error);
        }
    }

    public async add(channelCategory: ChannelCategory, vesselId: string) {
        try {
            const newCategory = await lastValueFrom(
                this.http.post<ChannelCategory>(`${this.domain}/api/channel-category`, {
                    channelCategory: channelCategory,
                })
            );
            await this.getList(vesselId);
            return newCategory;
        } catch (error) {
            console.error(error);
        }
    }

    public async update(channelCategory: ChannelCategory, vesselId: string) {
        try {
            await lastValueFrom(
                this.http.put<any>(`${this.domain}/api/channel-category`, {
                    params: channelCategory,
                })
            );
            await this.getList(vesselId);
        } catch (error) {
            console.error(error);
        }
    }

    public async delete(channelCategoryId: string, vesselId: string) {
        try {
            await lastValueFrom(this.http.delete(`${this.domain}/api/channel-category/${channelCategoryId}`));
            await this.getList(vesselId);
        } catch (error) {
            console.error(error);
        }
    }
}
